import "./Nav.css"
import logo from "../media/images/logo.png";
import search from "../media/images/search.png";
import telehpne from "../media/images/telephone-symbol-button.png";
import mail from "../media/images/email.png";
import { useNavigate } from "react-router-dom";
import menu from "../media/images/menu.png";
import { useState } from "react";
const Nav = () => {
    const navigate = useNavigate();
    const [dis,setDis]=useState("none");
    const home = ()=>{
        navigate("/")
    }
    const phoneMenu1=()=>{
        if(dis==="none"){
            setDis("block");
        }
        else{
            setDis("none")
        }
    }
    return ( 
        <div className="navbar">
            <div className="overtop">
                <div className="topContact">
                    <div className="slikaText">
                        <img src={telehpne} alt="s"/>
                        <p>+381 0230 505 863</p>
                    </div>
                    <div className="crta">
                        <p>|</p>
                    </div>
                    <div className="slikaText">
                        <img src={mail} alt="s"/>
                        <p>info@ecomodestudio.rs</p>
                    </div>
                </div>
            </div>
            <div className="menu">
                <div className="logo" onClick={home}>
                    <img src={logo} alt="logo"/>
                    <div className="logoText">
                        <p className="glavno">ecomode</p>
                        <p className="sporedno">studio</p>
                    </div>
                </div>
                <div className="menuPhone1">
                    <img src={menu} alt="menu" onClick={phoneMenu1}/>
                </div>
                <div className="menuPhone">
                    <ul style={{display:dis}}>
                        <li><a href="#lean"><p>LEAN SOLUTIONS</p></a></li>
                        <li><a href="#modular"><p>MODULAR SYSTEM</p></a></li>
                        <li><a href="#application"><p>APPLICATIONS</p></a></li>
                        <li><a href="#service"><p>SERVICE</p></a></li>
                    </ul>
                </div>
                <div className="mainMenu">
                    <ul>
                        <li><a href="#lean"><p>LEAN SOLUTIONS</p></a></li>
                        <li><a href="#modular"><p>MODULAR SYSTEM</p></a></li>
                        <li><a href="#application"><p>APPLICATIONS</p></a></li>
                        <li><a href="#service"><p>SERVICE</p></a></li>
                        <li><p>CONTACT</p></li>
                        <li><img src={search} alt="s"/></li>
                    </ul>
                </div>
            </div>
        </div>
     );
}
 
export default Nav;